import { useEffect, useState } from "react";
import { TaskType } from "api";
import { useRecoilState, useRecoilValue } from "recoil";
import { taskListAtom } from "recoil/taskListAtom";
import { userAtom } from "recoil/userAtom";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import { menuKeyType } from "./NestedList";
import ActivityList from "./ActivityList";

export const freeTaskList = ["0-0-A", "0-1", "0-2"];
export const onboardingTaskId = "0-0-A";

export default function LearningActivityList({
  data,
  dataUpdatedAt,
}: {
  data: TaskType[];
  dataUpdatedAt?: number;
}) {
  const { isNotStarted } = useSubscriptionStatus();

  const [taskListState, setTaskListState] = useRecoilState(taskListAtom);

  const userState = useRecoilValue(userAtom);

  const isCoach = userState?.accessToken && userState?.role !== "patient";

  const [listData, setListData] = useState<
    | {
        listTitle: string;
        taskList: TaskType[];
        menuKey: menuKeyType;
        initiallyOpen?: boolean;
      }[]
    | undefined
  >();

  useEffect(() => {
    if (data) {
      setTaskListState(
        !isCoach && isNotStarted
          ? data.map((each) => ({
              ...each,
              isLocked: !freeTaskList.includes(each.taskId),
            }))
          : data
      );
    }
  }, [data, dataUpdatedAt]);

  useEffect(() => {
    if (taskListState && taskListState.length > 0) {
      const todoList = taskListState.filter((element) => element.isOpen);
      setListData([
        ...(todoList.length > 0
          ? [
              {
                listTitle: "오늘의 활동",
                taskList: todoList,
                menuKey: "taskList_open" as menuKeyType,
                initiallyOpen: true,
              },
            ]
          : []),
      ]);
    }
  }, [taskListState]);

  return (
    <>
      <ActivityList
        title={"배움활동지"}
        isInitialLoading={!data}
        listData={listData}
      />
    </>
  );
}